import { render } from "./SliderApp.vue?vue&type=template&id=40c68014&scoped=true"
import script from "./SliderApp.vue?vue&type=script&lang=js"
export * from "./SliderApp.vue?vue&type=script&lang=js"

import "./SliderApp.vue?vue&type=style&index=0&id=40c68014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c68014"]])

export default __exports__